import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { Waypoint } from 'react-waypoint';

const fromFillToBase = (props: { baseColor: string; fillColor: string }) => keyframes`
    from {
        fill: ${props.fillColor};
    }
    to {
        fill: ${props.baseColor};
    }
`;

const fromBaseToFill = (props: { baseColor: string; fillColor: string }) => keyframes`
    from {
        fill: ${props.baseColor};
    }
    to {
        fill: ${props.fillColor};
    }
`;

const AnimatedFillSVG = styled.svg`
    .animateFill {
        animation: ${fromBaseToFill} 0.6s linear;
        animation-fill-mode: forwards;
    }
    .animateEmpty {
        animation: ${fromFillToBase} 0.6s linear;
        animation-fill-mode: forwards;
    }
`;

interface AnimatedStarIconProps {
    baseColor: string;
    fillColor: string;
    starIndex: number;
}

function AnimatedStarIcon({ baseColor, fillColor, starIndex }: AnimatedStarIconProps) {
    const [animateClass, setAnimate] = useState('');

    let scrollableAncestor: (Window & typeof globalThis) | null = null;
    if (typeof window !== 'undefined') {
        scrollableAncestor = window;
    }

    return (
        <Waypoint
            scrollableAncestor={scrollableAncestor}
            onEnter={() => setAnimate('animateFill')}
            onLeave={() => setAnimate('animateEmpty')}
            topOffset={`${starIndex * -8}%`}
            bottomOffset={`${starIndex * 8}%`}
        >
            <AnimatedFillSVG
                width="100%"
                height="100%"
                viewBox="0 0 512 512"
                baseColor={baseColor}
                fillColor={fillColor}
            >
                <path
                    className={animateClass}
                    fill={baseColor}
                    d="M189.501 153.319c5.815-13.761 54.464-121.736 58.006-132.471s10.678-14.777 19.95 5.838c9.271 20.616 51.708 110.349 53.476 123.451s15.753 25.586 32.353 25.586c16.599 0 133.403 12.005 146.209 12.005s18.327 5.583 4.123 15.731c-14.204 10.148-113.44 93.776-120.653 100.598s-12.255 13.761-6.622 31.166c5.634 17.404 32.469 125.702 36.846 139.28s-1.959 20.805-19.55 8.726c-17.591-12.081-103.106-63.086-113.593-69.105s-28.418-18.027-55.246 3.217c-26.828 21.245-99.382 60.602-112.007 69.875s-21.645 4.82-15.866-11.202c5.778-16.022 37.845-132.393 40.124-142.615s-0.958-26.392-15.939-36.975c-14.981-10.583-108.55-89.386-116.388-94.933s-7.867-14.6 15.020-14.6c22.887 0 126.921-12.552 141.089-12.552s22.851-7.257 28.666-21.018z"
                />
            </AnimatedFillSVG>
        </Waypoint>
    );
}

export default AnimatedStarIcon;
